import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import kmlParser from "js-kml-parser";
import { kml, gpx, tcx } from "@tmcw/togeojson";
import Place from "../../Models/Place";
import Group from "../../Models/Group";
import Appointment from "../../Models/Event";
import Places from "../../Models/Places";
import { DateTime } from "luxon";
import GoogleSearch from "../../Models/GoogleSearch";
import DatePicker from "react-datepicker";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { usePapaParse } from 'react-papaparse';
import Common, { SortByEnum, POI_IMAGES, COLORS } from "../../Common/Common";
import AlertModal from "./AlertModal";
//import MultiSelectModal from "./MultiSelectModal";
//try kml-to-json for creating kml from json

const KMLInput = (props) => {
  let ScheduleNames = useSelector((state) => state.ScheduleNames);

  const { readString } = usePapaParse();
  // let MultiselectItems = useSelector((state) => state.MultiselectItems);
  // let MultiselectSelectedItems = useSelector((state) => state.MultiselectSelectedItems);
  // let MultiselectMode = useSelector((state) => state.MultiselectMode);
  // let MultiselectSearchText = useSelector((state) => state.MultiselectSearchText);
  // let MultiselectTitle = useSelector((state) => state.MultiselectTitle);
  // let MultiselectCallback = useSelector((state) => state.MultiselectCallback);
  // let ShowMultiselect = useSelector((state) => state.ShowMultiselect);

  const dispatch = useDispatch();
  const [Inputs, SetInputs] = useState([]);
  const [TimeLineJSON, SetTimeLineJSON] = useState({});
  const [AllDates, SetAllDates] = useState([]);
  const [SelectedDates, SetSelectedDates] = useState([]);
  const [SavedGroupID, SetGroupID] = useState(0);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [Visited, setVisited] = useState(false);
  const [BucketListID, SetBucketListID] = useState(0);
  
  const [years, SetYears] = useState([2025]); 

  let user_info = useSelector((state) => state.user_info);
  console.log("props.file_type", props.file_type );

  let AllPlaces = useSelector((state) => state.places);

  useEffect(() => {
    SetInputs(props.PromptModalInputs);
  }, [props.PromptModalInputs]);

  const handleButtonClick = (button) => {
    //DirectionshHTML();
    if (button.Method != null) button.Method(result);
    props.onHide();
  };

  const handleInputChanged = (e, input) => {
    const index = Inputs.findIndex((x) => (x.name = input.name));
    if (index === -1) return;
    Inputs[index].value = e.target.value;
    SetInputs(Inputs);
    //console.log(Inputs);
  };

  const onKeyPress = (event) => {
    if (event.charCode === 13) {
      props.PromptModalButtons.forEach((button) => {
        if (button.Title === "OK") handleButtonClick(button);
      });
    }
  };

  //console.log("Inputs", Inputs);
  let file = null;
  const upload = async (e) => {
    // Convert the FileList into an array and iterate
    //console.log("e.target.files[0]", e.target.files[0])
    
    let files = Array.from(e.target.files).map((file) => {
      // Define a new file reader
      let reader = new FileReader();

      // Create a new promise
      return new Promise((resolve) => {
        // Resolve the promise after reading file
        reader.onload = () => resolve(reader.result);

        // Reade the file as a text
        //reader.readAsText(file);
        parseDocument(file);
      });
    });

    // At this point you'll have an array of results
    let res = await Promise.all(files);
  };

  // const fileChanged = async (e) => {
  //   // file = e.target.files[0];
  //   // parseDocument(file);
  //   Array.from(e.target.files).forEach((file) => {
  //     parseDocument(file);

  //     // // Define a new file reader
  //     // let reader = new FileReader();

  //     // // Function to execute after loading the file
  //     // reader.onload = () => console.log(reader.result);

  //     // // Read the file as a text
  //     // reader.readAsText(file);
  //   });
  // };

  let result = {};
  let _GroupID = 0;

  const parseDocument = async (file) => {
    //console.log("parseDocument props.file_type", props.file_type);        let groups = window.guide_obj.groups;
    

    let fileReader = new FileReader();
    if(props.file_type === "CSV"){
      if (file.name.toUpperCase().endsWith(".CSV")){
        fileReader.onload = function (event) {
          let GroupID = 0;
        let found = false;
        let filename = file.name;
        const fileParts = filename.split('.')
        let groups = window.guide_obj.groups;
        filename = fileParts[0];
            let groupName = filename + "_m";
            for (let x = 0; x < groups.length; x++) {
              if (groupName === groups[x].name) 
                {
                  found = true;
                  GroupID = groups[x].id;
                }
            }
            if(found === false){
              GroupID =  window.guide_obj.addGroup(groupName);
                let group = new Group();
                group.id = GroupID;
                group.name = groupName;
                group.poi_img = 16;
                window.guide_obj.modifyGroup(group, group);
            }
    
            SetGroupID(GroupID);
            const csvOutput = event.target.result;
            const glist = csvToStruct(csvOutput)
            //console.log("glist", glist);
            _GroupID = GroupID;
            
          myConfirm("Mark places as visited or bucket list?", [
            { Title: "Neither", Method: () => getMoreInfo(glist, filename, false, false) },
            { Title: "Visited", Method: () => getMoreInfo(glist, filename, true, false) },
            { Title: "Bucket List", Method: () => getMoreInfo(glist, filename, false, true) },
          ]);

            //setTimeout(() => getMoreInfo(glist), 200);
            
            //getMoreInfo(glist);

          //var url = 'http://www.google.com';
          //var request = require("request");
          // request({ url: glist[0].URL, followRedirect: false }, function (err, res, body) {
          //   console.log(res.headers.location);
          // });
          //fetchURL(glist[0].URL);
        };
        fileReader.readAsText(file)
      }
    }
    else if(props.file_type === "JSON"){
      if (file.name.toUpperCase().endsWith(".JSON")){
        fileReader.onload = function (event) {
          const jsonText = event.target.result;
          let json = JSON.parse(jsonText);
          SetTimeLineJSON(json);
          if(getTimelineDays(json) < 0) {
            alert("No dates found in file");
            return;
          }
          //props.onHide();
          //var url = 'http://www.google.com';
          //var request = require("request");
          // request({ url: glist[0].URL, followRedirect: false }, function (err, res, body) {
          //   console.log(res.headers.location);
          // });
          //fetchURL(glist[0].URL);
        };
        fileReader.readAsText(file)
      }
    }
    else {
    fileReader.onload = async (e) => {
      if (e.target.result.includes(`"guide":`)) {
        parseJSON(e.target.result);
        props.onHide();
        return;
      }
      console.log("e.target.result", e.target.result);
      //const geoJson = kmlParser.toGeoJson(e.target.result);
      let geoJson = {};
      if (file.name.toUpperCase().endsWith(".KML"))
        geoJson = kml(new DOMParser().parseFromString(e.target.result, "text/xml"));
      if (file.name.toUpperCase().endsWith(".GPX")) {
        //const geoJson2 = kmlParser.toGeoJson(e.target.result);
        geoJson = gpx(new DOMParser().parseFromString(e.target.result, "text/xml"));
      }
      if (file.name.toUpperCase().endsWith(".TCX"))
        geoJson = tcx(new DOMParser().parseFromString(e.target.result, "text/xml"));

      //console.log("geoJson", geoJson);
      if (typeof geoJson.features !== "undefined") parseGeoJSON(geoJson);
      props.onHide();
      //result = await extractGoogleCoords(e.target.result);

      //Do something with result object here
      //console.log(result);
    };
    if (file.name.toUpperCase().endsWith(".KMZ")) {
      var JSZip = require("jszip");
      JSZip.loadAsync(file).then(function (zip) {
        Object.keys(zip.files).forEach(function (filename) {
          zip.files[filename].async("string").then(function (fileData) {
            //console.log(fileData); // These are your file contents
            const geoJson = kmlParser.toGeoJson(fileData);
            console.log("geoJson", geoJson);
            parseGeoJSON(geoJson);
            props.onHide();
          });
        });
      });
      //}
      // JSZip.loadAsync(file)
      //   .then(function (content) {
      //     // if you return a promise in a "then", you will chain the two promises
      //     return content.files["css/style.css"].async("text");
      //   })
      //   .then(function (txt) {
      //     alert(txt);
      //   });
    } else fileReader.readAsText(file);
      
    }
  };

  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };
  
  const fetchURL = async (url) => {
    console.log("GoogleList2")
    let resp = ""
    fetch(url)
    .then(function (response) {
      return(response);
    })
  };
  

  // const fetchHTML = async (url) => {
  //   console.log("GoogleList2")
  //   fetch(`https://andiamotravelapp.com/api/scraper.php`)
  //   .then(response=>response)
  //   .then(result=>console.log(result))
  //   .catch(error=>console.error(error))
  // };
  
 const DirectionshHTML = () => {
  fetcDirectionshHTML("https://www.google.com/maps/dir/5727C+Adobe+Falls+Rd,+San+Diego,+CA+92120,+USA/Barnes+Tennis+Center,+4490+W+Point+Loma+Blvd,+San+Diego,+CA+92107-1006,+USA/@32.7679035,-117.2393117,12z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x80d9567920a2b93b:0xc4b7528a915bab09!2m2!1d-117.0764621!2d32.782511!1m5!1m1!1s0x80deaa44f09332eb:0x98244710c8223f2e!2m2!1d-117.234739!2d32.753489!3e0?entry=ttu&g_ep=EgoyMDI1MDQyOS4wIKXMDSoASAFQAw%3D%3D")
  }

  const fetcDirectionshHTML = async (url) => {
    fetch(url)
    // fetch('https://andiamotravelapp.com/api/scraper.php&url=${entry.URL}')
    .then(response => {
      // When the page is loaded convert it to text
      return response.text()
    })
    .then(html => {
    // Initialize the DOM parser
    const parser = new DOMParser()

    // Parse the text
    let doc = parser.parseFromString(html, "text/html")

    // You can now even select part of that html as you would in the regular DOM
    // Example:
    // const docArticle = doc.querySelector('article').innerHTML
    let head = doc.head.outerHTML;

console.log(head)


    // let saved_head = head;
    // let location = "0,0";
    // let place_id = "0";
    // //console.log("entry.URL", entry.URL);
    // //console.log("head", head);
    // let index = head.indexOf("https://www.google.com/maps/preview/place");
    // if(index === -1) return;
    // head = head.substring(index);
    // //console.log("index", index);
    // index = head.indexOf("@");
    // if(index === -1) return;
    // location = head.substring(index+1,index+24);
    // //console.log("location", location);
    // const points = location.split(",")
    // //console.log("points", points);
    // head = saved_head;
    // index = head.indexOf("https://search.google.com/local/reviews?placeid");
    // //console.log("index", index);
    // if(index === -1) return;
    // head = head.substring(index);
    // //console.log("head", head);
    // index = head.indexOf("u");
    // if(index === -1) return;
    // place_id = head.substring(index+5,index+32);
    // console.log("place_id, location", place_id, location);
    
    
    // const point = { Lat: parseFloat(points[0]), Longi: parseFloat(points[1]) };

    // const new_place = props.add_place_to_map("Icon", point, null, { name: entry.Title, info: entry.Note, imgURL: "" });
    // if(new_place === null) return;
    // //let place = window.guide_obj.places.getPlace(new_place);
    // //place.Link = entry.URL;
    // GoogleSearch.searchImages(`${entry.Title}`, processImages, {id: new_place.ID, link:entry.URL});
    // //return(head)
  })
  .catch(error => {
     console.error('Failed to fetch page: ', error)
  })
}

  const fetchHTML = async (entry, GroupID, visited, blID) => {
    fetch(entry.URL)
    //fetch(`https://andiamotravelapp.com/api/google_maps_list.php?url=${encodeURIComponent(entry.URL)}`)
    .then(response => {
      // When the page is loaded convert it to text
      return response.text()
    })
    .then(html => {
    // Initialize the DOM parser
    const parser = new DOMParser()

    // Parse the text
    let doc = parser.parseFromString(html, "text/html")

    // You can now even select part of that html as you would in the regular DOM
    // Example:
    // const docArticle = doc.querySelector('article').innerHTML
    let head = doc.head.outerHTML;
    let saved_head = head;
    let location = "0,0";
    let place_id = "0";
    //console.log("entry.URL", entry.URL);
    //console.log("head", head);
    let index = head.indexOf("https://www.google.com/maps/preview/place");
    if(index === -1) {
      //alert("Not a valid timeline file");
      console.log("Could not decode html")
      return;
    }
    head = head.substring(index);
    //console.log("index", index);
    index = head.indexOf("@");
    if(index === -1) return;
    location = head.substring(index+1,index+24);
    //console.log("location", location);
    const points = location.split(",")
    //console.log("points", points);
    // head = saved_head;
    // index = head.indexOf("https://search.google.com/local/reviews?placeid");
    // //console.log("index", index);
    // if(index === -1) return;
    // head = head.substring(index);
    // //console.log("head", head);
    // index = head.indexOf("u");
    // if(index === -1) return;
    // place_id = head.substring(index+5,index+32);
    // console.log("place_id, location", place_id, location);
    
    
    const point = { Lat: parseFloat(points[0]), Longi: parseFloat(points[1]) };
    let groups = [];
    if(GroupID !== 0)
      groups.push(GroupID)
    if(blID !== 0)
      groups.push(blID)
    const new_place = props.add_place_to_map("Icon", point, null, { name: entry.Title, info: entry.Note, imgURL: "", group: groups, visited: Visited });
    if(new_place === null) return;
    //let place = window.guide_obj.places.getPlace(new_place);
    //place.Link = entry.URL;
    GoogleSearch.searchImages(`${entry.Title}`, processImages, {id: new_place.ID, link:entry.URL});
    //return(head)
  })
  .catch(error => {
     console.error('Failed to fetch page: ', error)
  })
}

let main_page = "";
let html_entries = [];
  const processImages = (imageList, params) => {
    if (imageList.length === 0) {
      console.log("processImages: error");
      return;
    }
    console.log("processImages: success:", imageList[0].url);
    let place = window.guide_obj.places.getPlace(params.id);
    if (place === null) {
      console.log("processImages: place not found:", params.id);
      return;
    }
    place.Photo = imageList[0].url;
    place.Photo_m = imageList[0].url_m;
    place.Hlink = params.link
    
    const html_entry = `<a href="urllink:${params.link}"><button style="border: none; background: none; border-radius: 10%; font-size: 140%; padding: 5px; background-size: cover;"> <img style="border-radius: 10%;" src="${imageList[0].url_m}" width="336" height="268" /><br />${place.Name}</button></a>`
    
    html_entries.push({name: place.Name, html: html_entry})
    // try {
    //   place.Info = Place.createImageHTML(place.Photo_m, null, "medium"); // + place.Info;
    // } catch (e) {
    //   console.log("processImages: error", e.message);
    // }
  };

    
  const csvToStruct = (csvString) => {
    let GoogleList = [];
    readString(csvString, {
        header: true, // optional, if the CSV has a header row
        complete: (results) => {
          console.log('Results:', results.data); // Parsed data as an array of objects
          GoogleList = results.data;
          
        },
        error: (error) => {
          console.log('Error:', error);
        },
      });
    
    // const lines = csv.split('\n');
    // for(let i = 1; i < lines.length-1; i++)
    // {
    //   const params = lines[i].split(",");
    //   GoogleList.push({
    //     Title: params[0],
    //     Note: params[1],
    //     URL: params[2],
    //     Comment: params[3],
    //   })
    // }
    return(GoogleList);
  }

  const getMoreInfo = (glist, filename, visited, bucketlist) => {
      let blID = 0;
      let GroupID = 0;
      if(bucketlist === false){
        let groups = window.guide_obj.groups;
        let found = false;
        let groupName = filename + "_m";
        for (let x = 0; x < groups.length; x++) {
          if (groupName === groups[x].name) 
            {
              found = true;
              GroupID = groups[x].id;
            }
        }
        if(found === false){
           GroupID =  window.guide_obj.addGroup(groupName);
            let group = new Group();
            group.id = GroupID;
            group.name = groupName;
            group.poi_img = 16;
            window.guide_obj.modifyGroup(group, group);
        }
      }
        else{
          const bl = window.guide_obj.findGroupFromName("Bucket List_m");
          if(bl !== null)
            blID = bl.id;
        }
        SetGroupID(GroupID);
        setVisited(visited);
        SetBucketListID(blID);
      setTimeout(() => getMoreInfoPost(glist, GroupID, visited, blID), 100);
  }

  const getMoreInfoPost = (glist, GroupID, visited, blID) => {
    for(let i = 0; i < glist.length; i++){
      fetchHTML(glist[i], GroupID, visited, blID)
      // console.log("html", html);
      // const index = html.search("https://www.google.com/maps/preview/place")
      // if(index !== -1) html = html.substring(index)
      // console.log(html);
    }
    setTimeout(() => createMainPage(glist), 3000);
    props.onHide();
  }

  const createMainPage = (glist) => {
    // for(let i = 0; i < glist.length; i++){
    //  home_page += `<a href="urllink:${glist[i].URL}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">${glist[i].Title}</button></a>`;
    
    
    //  home_page += `<a href="urllink:${glist[i].URL}"><button style="border: none; background: none; border-radius: 10%; font-size: 140%; padding: 5px; background-size: cover;"> <img style="border-radius: 10%;" src="https://p0.pikist.com/photos/74/730/firenze-il-duomo-cathedral-cityscape-italy-rooftops-city-building-architecture-thumbnail.jpg" width="336" height="268" /><br />Duomo</button></a>`
    
    
    
    // }
    // html_entries.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
    // let home_page = "";
    // for(let i = 0; i < html_entries.length; i++){
    //   home_page += html_entries[i].html;
    // }
    // window.guide_obj.document = home_page;
    // dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
    // dispatch(slice1Actions.resetHomeScreen({ value: null }));
    // setTimeout(updateMustSee, 1000);
        let htmlString = window.guide_obj.document;
        const it = window.guide_obj.guide_settings.itinerary;
        if(it.directions === false && it.info === false &&  it.photo === true && it.place_menu === false)
          htmlString = window.guide_obj.createHTMLItinerary("Main", it);
        //dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
        //dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        //dispatch(slice1Actions.resetHTMLScreen());
  }








  const getTimelineDays = (timeline) => {
    if(typeof timeline.semanticSegments === "undefined")
    {
      alert("Not a valid timeline file");
      console.log(timeline);
      return(0);
    }
    let dates = [];
    //let Years = [];
    
    for (let i = 0; i < timeline.semanticSegments.length-1; i++) 
    {
      if(typeof timeline.semanticSegments[i].startTime !== "undefined"){
        let startTime = timeline.semanticSegments[i].startTime;
        let day = new Date(startTime);
        day.setMinutes(day.getMinutes() + day.getTimezoneOffset());
        day.setHours(0);
        day.setMinutes(0);
        day.setSeconds(0);
        const dayGetTime = day.getTime();
        if(!dates.includes(dayGetTime)) 
          dates.push(dayGetTime);
      }
    }
    // for(let j = 0; j < dates.length-1; j++){
    //   let year_ = dates[j].label.split("-");
    //   if(!Years.includes(year_[0])) Years.push(year_[0]);
    // }
    console.log("dates", dates)
    // console.log("Years", Years)
    SetAllDates(dates);
    // SetYears(Years);
    return(dates.length)
  }
  
   const selectDates = () => {
    // dispatch(slice1Actions.setMultiselectCallback({ value: selectDatesCallback }));
    // dispatch(slice1Actions.setMultiselectItems({ value: AllDates }));
    // dispatch(slice1Actions.setMultiselectSelectedItems({ value: SelectedDates }));
    // dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    // dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    // dispatch(slice1Actions.setMultiselectTitle({ value: "Select dates (14 max)" }));
    // dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };
  
 const selectDatesCallback = (dates) => {
    if (dates.length < 14) {
      alert("You can select a maximum of 14")
      return;
    }
    SetSelectedDates(dates);
    parseTimeline(TimeLineJSON);
  };

  const parseTimeline = (timeline, date) => {
    if(typeof timeline.semanticSegments === "undefined")
    {
      alert("Not a valid timeline file");
      console.log(timeline);
      return;
    }
    let month   = date.getUTCMonth() + 1; // months from 1-12
    let day     = date.getUTCDate();
    const year    = date.getUTCFullYear();
    const dateText = `${month}-${day}-${year}`
    const base62 = require("base62/lib/ascii");
    const geohash = require("ngeohash");
    let schedule = "";
    let scheds = window.guide_obj.schedule.geScheduleNames();
    for (let s = 1; s < 99999; s++) {
      schedule = `Itinerary${s}_${dateText}`;
      let found = false;
      for (let x = 1; x < scheds.length; x++) {
        if (schedule === scheds[x].label) found = true;
      }
      if (found === false) break;
    }
    let path_num = 0;
    let place_num = 0;
    let activity_num = 0;
    let last_place = null;
    let rounding_to = user_info.event_time_rounding;
    if (typeof rounding_to === "undefined") rounding_to = 30;
    if(month < 10) month = `0${month}`
    if(day < 10) day = `0${day}`
    const SearchDateText = `${month}-${day}-${year}`

    for (let i = 0; i < timeline.semanticSegments.length; i++) 
    {
      if(typeof timeline.semanticSegments[i].startTime !== "undefined" && typeof timeline.semanticSegments[i].endTime !== "undefined")
      { 
        let startTime = timeline.semanticSegments[i].startTime;
        let day = new Date(startTime);
        day.setMinutes(day.getMinutes() + day.getTimezoneOffset());
        day.setHours(0);
        day.setMinutes(0);
        day.setSeconds(0);
        const dayGetTime = day.getTime();
//"2023-07-26T02:34:41.000-07:00",
        let startDateISO = timeline.semanticSegments[i].startTime;
        let startDateISOt = startDateISO.split("T");
        let startDateISOm = startDateISOt[0].split("-");
        let startDateISOc = startDateISOt[1].split(":");
        const startDateText = `${startDateISOm[1]}-${startDateISOm[2]}-${startDateISOm[0]}`
        if(startDateText !== SearchDateText) continue;

        let startDate = DateTime.fromObject({ year: startDateISOm[0], month: startDateISOm[1], day: startDateISOm[2], hour: startDateISOc[0], minute: startDateISOc[0] })
        // startDateISO = startDateISO.substring(0, startDateISO.length-5) + "00:00"
        //let startDate = DateTime.fromISO(startDateISO, {zone: 'utc'}); //new Date(timeline.semanticSegments[i].startTime); //
        // let _startDate = Common.JSDateFromLuxonDate(startDate);
        // _startDate.setMinutes(_startDate.getMinutes() - day.getTimezoneOffset());
        // startDate = Common.LuxonDateFromJSDate(_startDate);
        
        let endDateISO = timeline.semanticSegments[i].endTime;
        let endDateISOt = endDateISO.split("T");
        let endDateISOm = endDateISOt[0].split("-");
        let endDateISOc = endDateISOt[1].split(":");
        let endDate = DateTime.fromObject({ year: endDateISOm[0], month: endDateISOm[1], day: endDateISOm[2], hour: endDateISOc[0], minute: endDateISOc[0] })
        
        // let endtDateISO = timeline.semanticSegments[i].endTime;
        // endtDateISO = endtDateISO.substring(0, endtDateISO.length-5) + "00:00"
        // let endDate = DateTime.fromISO(endtDateISO, {zone: 'utc'}); //new Date(timeline.semanticSegments[i].endTime); //
        // let _endDate = Common.JSDateFromLuxonDate(endDate);
        // _endDate.setMinutes(_endDate.getMinutes() - day.getTimezoneOffset());
        // endDate = Common.LuxonDateFromJSDate(_endDate);

        let points = "";
        let times = [];
        let time = null;
        let name = "";
        let elapsedSeconds = 0;
        let firstTimeStamp = 0;
        let info = "";
        let imgURL = "";
        let point_values = [0,0];
        let point_value = "0,0";
        let _mapCoordinate =  {
          Lat: 0,
          Longi: 0,
        };
        let location_type = null;
        if(typeof timeline.semanticSegments[i].timelinePath !== "undefined")
          location_type = "timelinePath";
        else if(typeof timeline.semanticSegments[i].activity !== "undefined")
          location_type = "activity";
        else if(typeof timeline.semanticSegments[i].visit !== "undefined")
          location_type = "visit";
        if(location_type === "timelinePath" || location_type === "activity")
        {
          const points_array = [];
          firstTimeStamp = 0;
          elapsedSeconds = 0;
          if(location_type === "timelinePath" ){
            for (let j = 0; j < timeline.semanticSegments[i].timelinePath.length; j++) 
            {
              if (typeof timeline.semanticSegments[i].timelinePath[j].time !== "undefined" && typeof timeline.semanticSegments[i].timelinePath[j].point !== "undefined") 
              //{
                points_array.push({point: timeline.semanticSegments[i].timelinePath[j].point, time: timeline.semanticSegments[i].timelinePath[j].time})
                // point_value = timeline.semanticSegments[i].timelinePath[j].point;
                // time = timeline.semanticSegments[i].timelinePath[j].time;
              //   point_values = point_value.split(",");
              //   if (firstTimeStamp === 0) firstTimeStamp = new Date(timeline.semanticSegments[i].startTime).getTime();
              //   else elapsedSeconds = (new Date(timeline.semanticSegments[i].timelinePath[j].time).getTime() - firstTimeStamp) / 1000;
              //   points +=
              //     ";" +
              //     geohash.encode(
              //       parseFloat(point_values[0]).toFixed(5),
              //       parseFloat(point_values[1]).toFixed(5)
              //     ) +
              //     "," +
              //     base62.encode(Math.round(elapsedSeconds));
              // }
              // _mapCoordinate =  {
              //   Lat: parseFloat(point_values[0]),
              //   Longi: parseFloat(point_values[1]),
              // };
            }
            if (name === "") {
              path_num+=1;
              name = "Path_" + path_num + "_" + dateText;
            }
          }
          if(location_type === "activity"){
            points_array.push({point: timeline.semanticSegments[i].activity.start.latLng, time: timeline.semanticSegments[i].startTime})
            points_array.push({point: timeline.semanticSegments[i].activity.end.latLng, time: timeline.semanticSegments[i].endTime})
            if (name === "") {
              activity_num+=1;
              name = "Activity_" + activity_num + "_" + dateText;
            }
          }
          for(let p= points_array.length-1; p >= 0 ; p--){
            point_values = points_array[p].point.split(",");
            if (firstTimeStamp === 0)  firstTimeStamp = new Date(points_array[p].time).getTime();
            else elapsedSeconds = (new Date(points_array[p].time).getTime() - firstTimeStamp) / 1000;
            points +=
              ";" +
              geohash.encode(
                parseFloat(point_values[0]).toFixed(5),
                parseFloat(point_values[1]).toFixed(5)
              ) +
              "," +
              base62.encode(Math.round(elapsedSeconds));
              _mapCoordinate =  {
                Lat: parseFloat(point_values[0]),
                Longi: parseFloat(point_values[1]),
              }
          }
          console.log("**PolyLine", "_mapCoordinate", _mapCoordinate, "points", points, "name", name );
          const new_path = props.add_place_to_map("PolyLine", _mapCoordinate, points, { name: name, info: info, imgURL: imgURL });
          addEvent(new_path, schedule, startDate, last_place, rounding_to, endDate, false);
        }
        if(location_type === "visit")
        {
          if (name === "") {
            place_num+=1;
            name = "Place_" + place_num+ "_" + dateText;
          }
          
          const place_id = timeline.semanticSegments[i].visit.topCandidate.placeId;
          const Hlink = `https://www.google.com/maps/place/?q=place_id:${place_id}`
          point_value = timeline.semanticSegments[i].visit.topCandidate.placeLocation.latLng;
          point_values = point_value.split(",");

          const point = { Lat: parseFloat(point_values[0]), Longi: parseFloat(point_values[1]) };
          const new_place = props.add_place_to_map("Icon", point, null, { name: name, info: info, imgURL: imgURL, Hlink: Hlink });
          if (new_place === null) return;
          console.log("daydate", startDate)
          addEvent(new_place, schedule, startDate, last_place, rounding_to, endDate, false);
          last_place = new_place;
        }
      }
    }
    dispatch(slice1Actions.setScheduleName({ value: schedule }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  }

  const sample_json = {
    guide: "Palermo4",
    name: "4 day Palermo itinerary",
    description: "4 day Palermo itinerary",
    schedule: "Palermo 4 days",
    image: "",
    cities: "Palermo",
    countries: "Italy",
    placemarks: [
      {
        name: "Cappella Palatina",
        categories: "Architecture,Castles,Religious sites",
        duration: 105,
        description:
          "The Palatine Chapel is the royal chapel of the Norman Palace in Palermo, Sicily. This building is a mixture of Byzantine, Norman and Fatimid … See more",
        url: "http://en.wikipedia.org/wiki/Cappella_Palatina",
        website: "https://www.cappellapalatinapalermo.it/",
        coordinates: "13.353610,38.110830",
        address: "Piazza del Parlamento, Palermo, Sicily 90134",
        country: "Italy",
        state: "Sicily",
        city: "Palermo",
        day: 1,
        image: "",
        image_t: "",
      },
    ],
  };

  let jsonfile = "";
  let JsonURL = "";
  const handleChangeJsonURL = (event) => {
    jsonfile = event.target.value;
  };
  const handleUploadTextFile = (guide_json) => {
    console.log(jsonfile);
    parseJSON(jsonfile);
    JsonURL = "";
    props.onHide();
  };
  const parseJSON = (guide_json) => {
    let json_guide = JSON.parse(guide_json);
    let guide_attributes = JSON.parse(JSON.stringify(window.guide_obj.attributes));
    let dateGuide = DateTime.now({ zone: "utc" });
    let cur_day = 0;
    let dayDate = "";
    let last_place = null;
    let day_offset = 0;
    const sheduleMain = window.guide_obj.schedule.getScheduleToDisplay("Main");
    if (sheduleMain.length === 0) {
      day_offset = Math.floor(Math.random() * 2500);
      day_offset = day_offset - 1250;
      dateGuide = dateGuide.plus({ days: day_offset });
    } else {
      console.log(sheduleMain[0]);
      dateGuide = DateTime.fromISO(sheduleMain[0].start, {zone: 'utc'});
    }
    dateGuide = dateGuide.set({ hour: 11 });
    dateGuide = dateGuide.set({ minutes: 0 });

    let new_guide = false;
    if (guide_attributes.guide_name === "New Guide") {
      new_guide = true;
      guide_attributes.guide_name = json_guide.name;
      guide_attributes.description = json_guide.description;
      guide_attributes.image_m = json_guide.image;
      guide_attributes.image = json_guide.image.replace(".jpg", "_t.jpg");

      //guide_attributes.language = json_guide.Language;
      //guide_attributes.rating = parseInt(json_guide.placemarks[i].Rating);
      if (!guide_attributes.countries.includes(json_guide.countries))
        guide_attributes.countries.push(json_guide.countries);
      if (!guide_attributes.cities.includes(json_guide.cities)) guide_attributes.cities.push(json_guide.cities);
    }
    for (let i = 0; i < json_guide.placemarks.length; i++) {
      if (typeof json_guide.placemarks[i].coordinates === "undefined") continue;
      if (json_guide.placemarks[i].coordinates.length !== 2) continue;
      let place = null;
      let mode = "modify";
      let existing_place = window.guide_obj.places.getPlacesFromName(json_guide.placemarks[i].name);
      if (existing_place === null) {
        place = new Place(window.guide_obj.places);
        mode = "new";
      } else place = existing_place;
      place.Name = json_guide.placemarks[i].name;
      place.Lat = json_guide.placemarks[i].coordinates[1];
      place.Longi = json_guide.placemarks[i].coordinates[0];
      place.Address = json_guide.placemarks[i].address;
      place.City = json_guide.placemarks[i].city !== "" ? json_guide.placemarks[i].city : json_guide.cities;
      place.State = json_guide.placemarks[i].state;
      place.Country = json_guide.placemarks[i].country !== "" ? json_guide.placemarks[i].country : json_guide.countries;
      place.Hlink = json_guide.placemarks[i].url;
      place.Photo = json_guide.placemarks[i].image_t;
      place.Photo_m = json_guide.placemarks[i].image;
      let info = json_guide.placemarks[i].description.replace(" … See more", "").replace("…", "");
      if (info.length > 200) info = info.substring(0, 149);
      place.Info = `<p style="text-align:center;"><img src="${place.Photo_m}" alt="Image" style="width:100%; max-width:700px; height:auto; border-radius:10%" ></img></p>${info}<a href="urllink:${place.Hlink}"> ... See More.</a><br>`;

      // place.Info = `<img src="${place.Photo}" alt="Image" style="float: left;
      // margin: 10px; width:350px; border-radius:10%" ></img><p style="margin: 10px;">${info}<a href="urllink:${place.Hlink}">... See More.</a></p><br style="clear:both;">`;
      place.PType = "Icon";
      for (let j = 0; j < json_guide.placemarks[i].categories.length; j++) {
        const this_category = json_guide.placemarks[i].categories[j];
        if (this_category === "") continue;
        let cat = window.guide_obj.getCategoryByName(this_category, "guide");
        if (cat !== null) {
          if (!place.Category.includes(cat.id)) place.Category.push(cat.id);
        } else {
          cat = window.guide_obj.getCategoryByName(this_category, "initial");
          if (cat !== null) {
            let cat2 = window.guide_obj.getCategoryByName(cat.name, "guide");
            if (cat2 === null) {
              window.guide_obj.addCategory(this_category);
              let catg = window.guide_obj.getCategoryByName(this_category, "guide");
              if (catg !== null) {
                window.guide_obj.modifyCategory(catg, cat);
                if (!place.Category.includes(catg.id)) place.Category.push(catg.id);
              }
            } else {
              if (!place.Category.includes(cat2.id)) place.Category.push(cat2.id);
            }
          } else console.log(`Category not found: ${this_category}`);
        }
      }
      // We don't need a group, each attraction is part of one or more schedules
      // let group = window.guide_obj.getGroupByName(json_guide.guide, "guide");
      // if (group !== null) {
      //   if (!place.Group.includes(group.id)) place.Group.push(group.id);
      // } else {
      //   // if (!place.Group.includes(group.id)) {
      //   window.guide_obj.addGroup(json_guide.guide);
      //   let group = window.guide_obj.getGroupByName(json_guide.guide, "guide");
      //   if (group !== null) {
      //     group.name = json_guide.guide;
      //     group.poi_img = "152";
      //     place.Group.push(group.id);
      //     window.guide_obj.modifyGroup(group, group);
      //   }
      //   // }
      // }
      if (mode === "new") window.guide_obj.places.addPlace(place);
      else window.guide_obj.places.modifyPlace(place, place.ID);
      // Dont add place in schedule
      if (json_guide.placemarks[i].day === 0) continue;
      mode = "modify";
      let event = null;
      let existing_event = window.guide_obj.schedule.findEventByName(json_guide.placemarks[i].name, sample_json.guide);
      if (existing_event === null) {
        event = new Appointment(window.guide_obj.schedule);
        mode = "new";
      } else event = existing_event;
      // let total_minutes = 0
      // for(let d = 0; d < json_guide.placemarks.length && d <= i; d++) total_minutes+=
      if (cur_day !== json_guide.placemarks[i].day) {
        last_place = null;
        dayDate = dateGuide.plus({ days: json_guide.placemarks[i].day });
        cur_day = json_guide.placemarks[i].day;
      }
      event.Subject = json_guide.placemarks[i].name;
      event.Body = ""; //place.Info;
      event.Itinerary = json_guide.schedule;
      let travel_time = 0;
      let rounding_to = user_info.event_time_rounding;
      if (last_place !== null) {
        const p1 = { latitude: last_place.Lat, longitude: last_place.Longi };
        const p2 = { latitude: place.Lat, longitude: place.Longi };
        let distance = Places.calculateDistance(p1, p2) * 1.2;
        travel_time = distance * 10;
        if (travel_time > 45) travel_time = distance * 2;
        if (rounding_to === 0) travel_time = 0;
        else travel_time = Math.max(1, Math.round(travel_time / rounding_to)) * rounding_to;
      }
      last_place = place;
      dayDate = dayDate.plus({ minutes: travel_time });
      event.Start = dayDate.toISO(); //({ zone: "utc" });
      dayDate = dayDate.plus({ minutes: json_guide.placemarks[i].duration });
      event.End = dayDate.toISO(); //({ zone: "utc" });
      if (!event.Places.includes(place.ID)) event.Places = place.ID;
      if (mode === "new") window.guide_obj.schedule.addEvent(event);
      else window.guide_obj.schedule.modifyEvent(event);
    }
    //if (sheduleMain.length === 0) window.guide_obj.schedule.copySchedule(json_guide.schedule, "Main");
    //let GuideSettings = useSelector((state) => state.GuideSettings);
    let GuideSettings = {
      mode: "edit", // "edit" "view" "custom_view"
      zoom: 5,
      hide_schedule: false,
      hide_hidden: false,
      wrap_text: false,
      places_list: {
        menu: false,
        info: true,
        url: false,
        attributes: true,
        center: false,
        filter: false,
        path_link: false,
      },
      places_map: {
        menu: true,
        info: false,
        url: false,
        attributes: false,
        center: false,
        filter: false,
        path_link: false,
      },
      places_map_hover: {
        menu: false,
        place: true,
        info: true,
        event: true,
        path_link: false,
      },
      event: {
        menu: true,
        details: false,
        center: false,
        filter: false,
      },
      schedule: {
        menu: true,
        itinerary: false,
        center: false,
        filter: false,
      },
      day: {
        menu: true,
        center: false,
        filter: false,
      },
      itinerary: {
        directions: true,
        info: true,
        photo: false,
        place_menu: true,
      },
    };
    //GuideSettings.mode = "custom_view";
    dispatch(slice1Actions.setGuideSettings({ value: GuideSettings }));
    let scheds = window.guide_obj.schedule.geScheduleNames(); //JSON.parse(JSON.stringify(ScheduleNames));
    //scheds.push({ label: json_guide.schedule });
    scheds = scheds.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    let days = [];
    let labels = [];
    for (let s = 0; s < scheds.length; s++) {
      const scheds_parts = scheds[s].label.split(" ");
      const length = scheds_parts.length;
      if (length >= 3) {
        labels.push({ sched: scheds[s].label, label: `${scheds_parts[length - 2]} ${scheds_parts[length - 1]}` });
        days.push(parseInt(scheds_parts[length - 2]));
      }
    }
    let continuos = true;
    for (let n = 0; n < days.length - 1; n++) {
      if (days[n + 1] !== days[n] + 1) continuos = false;
    }
    let title = `${json_guide.cities} `;

    if (continuos) {
      if (days.length > 1) title = `${json_guide.cities} ${days[0]}-${days[days.length - 1]}`;
      else title = `${json_guide.cities} ${days[0]}`;
    } else
      for (let n = 0; n < days.length; n++) {
        title += `${days[n]}${n < days.length - 1 ? "," : ""}`;
      }
    title += days.length > 2 ? " days" : " day";
    const desc = title + " itinerary";

    let center = { latitude: 0, longitude: 0 };
    if (typeof json_guide.coordinates !== "undefined" && typeof json_guide.coordinates !== "") {
      //MapCenter = { lat: json_guide.coordinates[1], lng: json_guide.coordinates[0] };
      center = { latitude: json_guide.coordinates[1], longitude: json_guide.coordinates[0] };
      guide_attributes.base_location = { latitude: json_guide.coordinates[1], longitude: json_guide.coordinates[0] };
    } else {
      const weighted_center = window.guide_obj.places.getWeightedCenter(null);
      center = { latitude: weighted_center.lat, longitude: weighted_center.lon };
      guide_attributes.base_location = { latitude: weighted_center.lat, longitude: weighted_center.lon };
    }

    window.guide_obj.schedule.deleteAllEvents("Main");
    if (scheds.length > 1) window.guide_obj.schedule.copySchedule(scheds[scheds.length - 2].label, "Main");
    guide_attributes.guide_name = title;
    guide_attributes.description = desc;
    guide_attributes.access = ["Featured", "All_C"];
    guide_attributes.type = "Featured";
    window.guide_obj.attributes.modifyGuideAttributes(guide_attributes);

    let home_page = `<p style="text-align:center;"><img src="${json_guide.image}" alt="Image" style="width:100%; max-width:700px; height:auto; border-radius:10%" ></img></p>`;
    home_page += `<p><h3 style="text-align:center;">${title}</h3></p></br>`;

    if (typeof json_guide.info !== "undefined")
      home_page += `<a href="urllink:${json_guide.info}">General info for ${json_guide.cities}</a><br><br>`;

    //if (labels.length > 0) home_page += `<span><b>Show Schedule for:</b></span><br>`;
    // for (let i = 0; i < labels.length; i++) {
    //   if (labels[i].label === "Main") continue;
    //   home_page += `<a href="schedulelink:${labels[i].sched}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #FEC02D;">${labels[i].label}</button></a>`;
    //   //home_page += `<a href="schedulelink:${scheds[i].label}">Show schedule for "${scheds[i].label}"</a><br>`;
    // }
    // home_page += `<br>`;

    if (labels.length > 0) home_page += `<span><b>Show Itinerary for:</b></span><br>`;
    for (let i = 0; i < labels.length; i++) {
      if (labels[i].label === "Main") continue;
      home_page += `<a href="itinerarylink:${labels[i].sched}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #36D1E5;">${labels[i].label}</button></a>`;
      // home_page += `<a href="itinerarylink:${scheds[i].label}">Show itinerary for "${scheds[i].label}"</a><br>`;
    }
    home_page += `<br>`;
    home_page += `<span><b>Internet Resources:</b></span><br>`;
    if (typeof json_guide.weather !== "undefined" && last_place !== null)
      //home_page += `<a href="weatherlink:${last_place.ID}">Show weather forecast for "${json_guide.cities}"</a><br><br>`;
      home_page += `<a href="weatherlink:${last_place.ID}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Weather</button></a>`;

    if (typeof json_guide.climate !== "undefined")
      //home_page += `<a href="urllink:${json_guide.climate}">Show yearly climate for ${json_guide.cities}</a><br>`;
      home_page += `<a href="urllink:${json_guide.climate}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Climate</button></a>`;

    const videos = `https://www.youtube.com/results?search_query=${json_guide.cities}+${json_guide.countries}+attractions`;
    home_page += `<a href="urllink:${videos}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Videos</button></a>`;
    const articles = `http://www.google.com/search?q=${json_guide.cities}+${json_guide.countries}+Travel+Itinerary`;
    home_page += `<a href="urllink:${articles}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Articles</button></a>`;

    if (last_place !== null) {
      //home_page += `<a href="urllink:https://www.yelp.com/search?find_loc=${center.latitude},${center.longitude}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Yelp</button></a>`;
      home_page += `<a href="urllink:https://www.happycow.net/searchmap?s=3&location=&filters=vegan-vegetarian-vegfriendly&metric=mi&limit=81&order=default&lat=${center.latitude}&lng=${center.longitude}&zoom=15&page=1"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Vegan</button></a>`;
      home_page += `<a href="urllink:http://maps.google.com/maps?q=${center.latitude},${center.longitude}"><button style="border: none; padding: 20px; margin: 10px; color: white; border-radius: 10%; font-size: 100%; background-color: #64DB65;">Google Maps</button></a>`;
    }

    home_page += `<br><br><p><span style="font-size: 60%;">Credits: Itineraries from <a href="urllink:https://www.bing.com/maps/">Bing Maps</a>. Attraction info and images from <a href="urllink:https://www.wikipedia.org/">Wikipedia</a>. Under the CC BY-SA licensing agreement</span></p>`;

    window.guide_obj.document = home_page;
    // if (window.guide_obj.document === "") {
    //   const itinerary = window.guide_obj.createHTMLItinerary(json_guide.schedule, GuideSettings.itinerary);
    //   window.guide_obj.document = itinerary;
    // }
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    setTimeout(updateMustSee, 200);
  };
  const updateMustSee = () => {
    const countTimesInSchedule = window.guide_obj.schedule.countTimesInSchedule();
    let scheds = window.guide_obj.schedule.geScheduleNames();
    console.log("countTimesInSchedule", countTimesInSchedule);
    for (let i = 0; i < countTimesInSchedule.length; i++) {
      const place = window.guide_obj.places.getPlace(countTimesInSchedule[i].placeID);
      if (place === null) continue;
      place.MustSee = countTimesInSchedule[i].count >= (scheds.length - 1) / 2;
      window.guide_obj.places.modifyPlace(place, place.ID);
    }

    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
  };
  
  const parseGeoJSON = (geoJson) => {
    if (typeof geoJson.features === "undefined") return;
    const base62 = require("base62/lib/ascii");
    const geohash = require("ngeohash");
    let schedule = "";
    let scheds = window.guide_obj.schedule.geScheduleNames();
    for (let s = 1; s < 99999; s++) {
      schedule = `Itinerary${s}`;
      let found = false;
      for (let x = 1; x < scheds.length; x++) {
        if (schedule === scheds[x].label) found = true;
      }
      if (found === false) break;
    }

    let dateGuide = DateTime.now({ zone: "utc" });
    dateGuide = dateGuide.set({ hour: 11 });
    dateGuide = dateGuide.set({ minutes: 0 });
    let dayDate = dateGuide;
    let last_place = null;
    let rounding_to = user_info.event_time_rounding;
    if (typeof rounding_to === "undefined") rounding_to = 30;
    // try {
    for (let i = 0; i < geoJson.features.length; i++) {
      let placeMark = geoJson.features[i];
      let name = placeMark.properties.name;
      let info = placeMark.properties.description;
      if (typeof name === "undefined") name = "";
      if (typeof info === "undefined") info = "";
      let imgURL = "";
      if (placeMark.properties.title != null && typeof placeMark.properties.title !== "undefined")
        name = placeMark.properties.title;
      if (placeMark.properties.time != null && typeof placeMark.properties.time !== "undefined")
        info += "time: " + placeMark.properties.time;
      if (placeMark.properties.ascent != null && typeof placeMark.properties.ascent !== "undefined")
        info += " ascent: " + placeMark.properties.ascent + "m";
      if (placeMark.properties.descent != null && typeof placeMark.properties.descent !== "undefined")
        info += " descent: " + placeMark.properties.descent + "m";
      if (placeMark.properties.imgURL != null && typeof placeMark.properties.imgURL !== "undefined")
        imgURL = placeMark.properties.imgURL;
      if (placeMark.geometry !== "undefined" && placeMark.geometry !== null)
      {
        if (placeMark.geometry.type === "Point") {
          const point = { Lat: placeMark.geometry.coordinates[1], Longi: placeMark.geometry.coordinates[0] };
          const new_place = props.add_place_to_map("Icon", point, null, { name: name, info: info, imgURL: imgURL });
  
          if (new_place === null) return;
          dayDate = addEvent(new_place, schedule, dayDate, last_place, rounding_to);
          last_place = new_place;
        } else if (placeMark.geometry.type === "LineString") {
          if (true === false) {
            let points = "";
            let time = null;
            for (let j = 0; j < placeMark.geometry.coordinates.length; j++) {
              if (points !== "") points += ":";
              points += placeMark.geometry.coordinates[j][0] + "," + placeMark.geometry.coordinates[j][1];
            }
            const _mapCoordinate = {
              Lat: placeMark.property.coordinates[0][1],
              Longi: placeMark.geometry.coordinates[0][0],
            };
            if (name === "") name = "New Path";
            props.add_place_to_map("PolyLine", _mapCoordinate, points, { name: name, info: info, imgURL: imgURL });
          } else {
            let points = "";
            let times = [];
            if (typeof placeMark.properties.coordinateProperties !== "undefined")
              if (typeof placeMark.properties.coordinateProperties.times !== "undefined")
                times = placeMark.properties.coordinateProperties.times;
            let time = null;
  
            let elapsedSeconds = 0;
            let firstTimeStamp = 0;
            for (let j = 0; j < placeMark.geometry.coordinates.length; j++) {
              if (typeof times[j] !== "undefined") {
                time = times[j];
                if (firstTimeStamp === 0) firstTimeStamp = new Date(time).getTime();
                else elapsedSeconds = (new Date(time).getTime() - firstTimeStamp) / 1000;
  
                //firstTimeStamp = time;
                //console.log("new Date(time)", new Date(time), new Date(time).getTime());
                //if (points !== "") points += ":";
                //points += placeMark.geometry.coordinates[j][0] + "," + placeMark.geometry.coordinates[j][1];
                console.log(placeMark.geometry.coordinates[j]);
                points +=
                  ";" +
                  geohash.encode(
                    parseFloat(placeMark.geometry.coordinates[j][1]).toFixed(5),
                    parseFloat(placeMark.geometry.coordinates[j][0]).toFixed(5)
                  ) +
                  "," +
                  base62.encode(Math.round(elapsedSeconds));
                // let alt = Math.round(placeMark.geometry.coordinates[j][2] * 10);
                // points += "," + base62.encode(alt);
              } else {
                if (points !== "") points += ":";
                points += placeMark.geometry.coordinates[j][0] + "," + placeMark.geometry.coordinates[j][1];
              }
            }
            const _mapCoordinate = {
              Lat: placeMark.geometry.coordinates[0][1],
              Longi: placeMark.geometry.coordinates[0][0],
            };
            if (name === "") name = "New Path";
            props.add_place_to_map("PolyLine", _mapCoordinate, points, { name: name, info: info, imgURL: imgURL });
          }
        } else if (placeMark.geometry.type === "Polygon") {
          let points = "";
  
          for (let j = 0; j < placeMark.geometry.coordinates[0].length; j++) {
            if (points !== "") points += ":";
            points += placeMark.geometry.coordinates[0][j][0] + "," + placeMark.geometry.coordinates[0][j][1];
          }
          const _mapCoordinate = {
            Lat: placeMark.geometry.coordinates[0][0][1],
            Longi: placeMark.geometry.coordinates[0][0][0],
          };
          if (name === "") name = "New Area";
          props.add_place_to_map("Polygon", _mapCoordinate, points, { name: name, info: info, imgURL: imgURL });
        }

      }
    }
    dispatch(slice1Actions.setScheduleName({ value: schedule }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    // } catch (e) {
    //   alert(e.message);
    // }
  };

  const addEvent = (place, Itinerary, startDate, last_place, rounding_to, endDate, travel_duration) => {
    //console.log("addEvent startDate", startDate.toISO());
    //console.log("addEvent endDate", endDate.toISO());
    
    let calculatedEND = endDate;
    let travel_time = 0;
    if (last_place !== null && travel_duration !== false) {
      const p1 = { latitude: last_place.Lat, longitude: last_place.Longi };
      const p2 = { latitude: place.Lat, longitude: place.Longi };
      let distance = Places.calculateDistance(p1, p2) * 1.2;
      travel_time = distance * 10;
      if (travel_time > 45) travel_time = distance * 2; //Math.min(distance * 2, 60);
      if (rounding_to === 0) travel_time = 0;
      else travel_time = Math.max(1, Math.round(travel_time / rounding_to)) * rounding_to;
      calculatedEND = startDate.plus({ minutes: travel_time });
      calculatedEND = calculatedEND.plus({ minutes: place.Duration });
    }
    let event = new Appointment(window.guide_obj.schedule);
      event.Start = startDate.toISO();
      event.End = event.Start;
      try{
      if(typeof endDate !== "undefined") event.End = endDate.toISO();
    }
    catch{
      if(calculatedEND !== "undefined") event.End = calculatedEND.toISO();
    }
    event.Subject = place.Name;
    event.Body = "";
    event.Itinerary = Itinerary;
    event.Places = place.ID;
    window.guide_obj.schedule.addEvent(event);
    return startDate;
  };

  const extractGoogleCoords = async (plainText) => {
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(plainText, "text/xml");
    let googlePolygons = [];
    let googleMarkers = [];
    let googlePolylines = [];

    if (xmlDoc.documentElement.nodeName == "kml") {
      for (const item of xmlDoc.getElementsByTagName("Placemark")) {
        let placeMarkName = item.getElementsByTagName("name")[0].childNodes[0].nodeValue.trim();
        let LineString = item.getElementsByTagName("LineString");
        let coordinates = item.getElementsByTagName("coordinates");
        let coordinates_inner = coordinates[0].innerHTML;
        let polygons = item.getElementsByTagName("Polygon");
        let markers = item.getElementsByTagName("Point");
        let polylines = item.getElementsByTagName("Polyline");

        /** POLYGONS PARSE **/
        for (const polygon of polygons) {
          let coords = polygon.getElementsByTagName("coordinates")[0].childNodes[0].nodeValue.trim();
          let points = coords.split(" ");

          let googlePolygonsPaths = [];
          for (const point of points) {
            let coord = point.split(",");
            googlePolygonsPaths.push({ name: placeMarkName, lat: +coord[1], lng: +coord[0] });
          }
          googlePolygons.push(googlePolygonsPaths);
        }

        /** POLYLINES PARSE **/
        for (const polyline of polylines) {
          let coords = polyline.getElementsByTagName("coordinates")[0].childNodes[0].nodeValue.trim();
          let points = coords.split(" ");

          let googlePolylinesPaths = [];
          for (const point of points) {
            let coord = point.split(",");
            googlePolylinesPaths.push({ name: placeMarkName, lat: +coord[1], lng: +coord[0] });
          }
          googlePolylines.push(googlePolylinesPaths);
        }

        /** MARKER PARSE **/
        for (const marker of markers) {
          var coords = marker.getElementsByTagName("coordinates")[0].childNodes[0].nodeValue.trim();
          let coord = coords.split(",");
          googleMarkers.push({ name: placeMarkName, lat: +coord[1], lng: +coord[0] });
        }
      }
    } else {
      throw "error while parsing";
    }

    return { markers: googleMarkers, polygons: googlePolygons, polylines: googlePolylines };
    console.log({ markers: googleMarkers, polygons: googlePolygons, polylines: googlePolylines });
  };
  // const writeFile = () => {
  //   const fs = require("fs");
  //   const content = "Some content!";
  //   fs.writeFile("../../Guides/Rome.txt", content, (err) => {
  //     if (err) {
  //       console.error(err);
  //       return;
  //     }
  //     //file written successfully
  //   });
  // };

  // if (ShowMultiselect)
  //   return (
  //     <MultiSelectModal
  //       show={ShowMultiselect}
  //       onHide={() => dispatch(slice1Actions.setShowMultiselect({ value: false }))}
  //       MultiselectItems={MultiselectItems}
  //       MultiselectSelectedItems={MultiselectSelectedItems}
  //       MultiselectMode={MultiselectMode}
  //       MultiselectCallback={MultiselectCallback}
  //       MultiselectTitle={MultiselectTitle}
  //       MultiselectSearchText={MultiselectSearchText}
  //     />
  //   );
  // else {

    // const [startDate, setStartDate] = useState(new Date());
    // const months = [
    //   "January",
    //   "February",
    //   "March",
    //   "April",
    //   "May",
    //   "June",
    //   "July",
    //   "August",
    //   "September",
    //   "October",
    //   "November",
    //   "December",
    // ];

    //const disabledDates = [tomorrow, in3Days, in5Days];

  function tileDisabled({ date, view }) {
    // Disable tiles in month view only
    if (view === 'month') {
      // Check if a date React-Calendar wants to check is on the list of disabled dates
      return(!AllDates.includes(date.getTime()));
    }
  }
  const onCalendarChange = (date) => {
    console.log(date);
    parseTimeline(TimeLineJSON, date);
  }
  const [calendarDate, setCalendarDate] = useState(new Date());
  
  return (
    <div className="modal">
      <Modal
        {...props}
            size="md"
            //minHeight="800px"
            center={false}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable={true}
        onHide={() => props.onHide()}
      >
        <Modal.Body>
          <div className="sort">
            {/* <h4 style={{ color: "#3598DB" }}>{props.PromptModalTitle}</h4> */}
            <h4 style={{ color: "#3598DB" }}>Select File</h4>
            {/* <h6 style={{ color: "black" }}>
              {props.message}
            </h6> */}
            <div>
              {/* <p>{props.PromptModalMessage}</p> */}
              <label for="file-upload" className="custom-file-upload">
                <FontAwesomeIcon title="Select File" icon={solid("folder")} size="5x"></FontAwesomeIcon>
              </label>
              <input
                ref={(input) => input && input.focus()}
                className="form-item"
                placeholder="Choose file"
                style={{ width: "250px" }}
                type="file"
                accept={props.file_type === "KML" ? ".kml,.kmz,.gpx,.tcx" : props.file_type === "CSV" ? ".csv" : ".json"}
                onChange={upload}
                id="file-upload"
                multiple
              ></input>
            </div>


            {props.file_type === "JSON" && AllDates.length > 0 ?  
            <div>
              <h4 style={{ color: "#3598DB" }}>Select Date</h4>
              <Calendar
                  onChange={onCalendarChange}
                  value={calendarDate}
                  tileDisabled={tileDisabled}
                />

            </div>



            : null} 

    {/* <DatePicker
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <select
            value={date.getYear}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[date.getMonth]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
      selected={startDate}
      onChange={(date) => setStartDate(date)}
    /> */}
            
  
 



{/* <p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p>

<p></p> */}


            {props.PromptModalButtons.map((button, i) => (
              <Button
                key={i}
                variant="primary"
                style={{ width: "200px" }}
                className="my-2"
                onClick={() => handleButtonClick(button)}
              >
                {"Exit"}
              </Button>
            ))}
            
            {/* {user_info.uid === "E2Fqqu9FWDgTdpOzdKQOKEdo6wA3" ? (
              <div>
                <textarea
                  id={"text-field"}
                  rows={8}
                  onChange={handleChangeJsonURL}
                  placeholder="Enter KML"
                  value={JsonURL}
                  style={{ width: "100%", height: "100%", fontSize: "16px" }}
                />
                <Button
                  key={"upload"}
                  id={"upload-button"}
                  variant="primary"
                  style={{ width: "200px" }}
                  onClick={() => handleUploadTextFile()}
                >
                  Upload
                </Button>
              </div>
            ) : null} */}
            {/* <p>Change Start date</p>
            <p>Move one day</p>
            <p>Add one day</p>
            <p>Delete Schedule</p>
            <p>Rename Schedule</p>
            <p>Edit Schedule</p> */}
          </div>
        </Modal.Body>
      </Modal>
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
    </div>
    
  );
// };
};

export default KMLInput;
